import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TesteService } from 'src/app/services/teste.service';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class homeComponent implements OnInit {

  form: FormGroup;
  cod_area:string;
  desc_area:string;
  filtro :string;
  dataTableFieldFilter = new FormControl({value: '', disabled: false});

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'},
    {value: 'tacos-3', viewValue: 'Tacss'}
  ];

  panelOpenState = false;

  listagem = [];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  colunas = ['data', 'horario', 'numero', 'modalidade','agrupamento','titulo', 'sei', 'detalhamento' ];

  filteredVariables = this.foods.slice();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private testeService: TesteService, private matDialod: MatDialog, private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.initForm();

    this.testeService.listaEdital().then((data: any) => {console.log(data);
      // this.listagem = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      this.customDataSource();
    });

  }





  abrirDialog() {
    this.matDialod.open(DialogComponent);
  }

  abrirSnack() {
    this._snackBar.open('Snackbar gerado com sucesso', 'OK', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  customDataSource() {
    this.paginator._intl.itemsPerPageLabel = 'Itens por página:';
  }

  criar() {
    const data = {
      id: 1001,
      title: 'Teste Pacheco',
      body: 'Estamos testando a API com angular.',
      userId: 1
    };

    this.testeService.criar(data).subscribe(resp => {
      console.log('Resposta', resp);
    }, error => console.error('Erro ao tentar gravar', error));

  }

  filtrar(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  goToAnalise(param: any) {
    /// carrega o objeto para o service
    this.testeService.pub_inscricao = param;


    this.testeService.ppub_numero = param.numero;
    this.testeService.ppub_processo = param.processo;
    this.testeService.ppub_sei = param.sei;
    this.testeService.ppub_data = param.data;
    this.testeService.ppub_modalidade = param.modalidade;
    this.testeService.ppub_horario = param.horario;
    this.testeService.ppub_agrupamento = param.agrupamento;
    this.testeService.ppub_titulo = param.titulo;
    this.testeService.ppub_descricao = param.descricao;
    this.testeService.ppub_suspensa = param.suspensa;
   
    /// navega para a ANALISE
    this.testeService.pub_ope='A'
    this.router.navigate(['/analise'])
  }


  goToEmail(param: any) {
    /// carrega o objeto para o service
    this.testeService.pub_inscricao = param;
    /// navega para a email
    this.router.navigate(['/comunicacao']);
  }

  incluir() {
    /// carrega o objeto para o service
    ///this.testeService.nextEvento().subscribe(resp => {
      /// console.log(' aqui   '+resp);
     ///  this.testeService.pub_ope='I';
     ///  this.testeService.pub_inc=resp;
     ///  this.router.navigate(['/analise']);
     this.router.navigate(['/acesso']);
   /// }, erro => console.error(erro));
  }











  goToPublica(param : any) {
    /// carrega o objeto para o service
    this.testeService.pub_inscricao = param.titulo;
    console.log(' ===PUB===---===',this.testeService.pub_inscricao,'===---===---===');
    //this.testeService.PublicaEvento( this.testeService.pub_inscricao);
    //this.router.navigate(['/administra']);

    if(confirm("Confirma a Publicação do Evento?")){
      //this.testeService.incluirInscricao(this.form.value).subscribe(resp => {});
      ///this.testeService.PublicaEvento(this.testeService.pub_inscricao).subscribe(resp => {
      ///  console.log(resp);
      ///  this.router.navigate(['/administra']);
      ///}, erro => console.error(erro));


  }
  this.router.navigate(['/administra']);
  }

  goToDesPublica(param : any) {
    /// carrega o objeto para o service
    //this.testeService.pub_inscricao = param.id_evento;
    //this.testeService.DesPublicaEvento( this.testeService.pub_inscricao);
    //this.router.navigate(['/administra']);
    this.testeService.pub_inscricao = param.titulo;
    console.log(' ===DES===---===',this.testeService.pub_inscricao,'===---===---===');
    //this.testeService.PublicaEvento( this.testeService.pub_inscricao);
    //this.router.navigate(['/administra']);

    if(confirm("Confirma a Despublicação do Evento?")){
      //this.testeService.incluirInscricao(this.form.value).subscribe(resp => {});
      ///this.testeService.DesPublicaEvento(param).subscribe(resp => {
      ///  console.log(resp);
     ///   this.router.navigate(['/administra']);
      ///}, erro => console.error(erro));


  }


  this.router.navigate(['/administra']);


  }


excluirEvento(param : any){

  if(confirm("Confirma a Exclusão do Evento?")){

    this.testeService.pub_inscricao = param.id_evento;
   /// this.testeService.excluiEvento(param).subscribe(resp => {
   ///   console.log(resp);
   ///   this.router.navigate(['/administra']);
   /// }, erro => console.error(erro));


    }


}



  initForm() {
    this.form = this.fb.group({
      prontuario: '',
      nome: '',
      cpf: '',
      nascimento: '',
      idade: '',
      sexo: '',
      cns: '',
      status: '',
      unidade: '',
      start: '',
      end: '',
      filtro: ''
    });
  }

}

interface Food {
  value: string;
  viewValue: string;
}